import * as api from "../Services/api.js";
import ServiceRate from "../../objs/ServiceRate";
import InvoiceBatch from "../../objs/InvoiceBatch";
import SessionInvoice from "../../objs/SessionInvoice";

export const state = {
  serviceRates: [],
  invoiceBatches: [],
  selectedInvoiceBatch: null,
};

export const mutations = {
  SET_SERVICE_RATES(state, payload) {
    state.serviceRates = payload.map((item) => new ServiceRate(item));
  },
  ADD_SERVICE_RATE(state, payload) {
    state.serviceRates.push(new ServiceRate(payload));
  },
  UPDATE_SERVICE_RATE(state, payload) {
    state.serviceRates = state.serviceRates.map((item) => {
      return item.serviceRateId == payload.serviceRateId
        ? new ServiceRate(payload)
        : item;
    });
  },
  DELETE_SERVICE_RATE(state, serviceRateId) {
    state.serviceRates = state.serviceRates.filter(
      (item) => item.serviceRateId != serviceRateId
    );
  },
  SET_INVOICE_BATCHES(state, payload) {
    state.invoiceBatches = payload.map((item) => new InvoiceBatch(item));
  },
  ADD_INVOICE_BATCHES(state, payload) {
    payload.map((item) => {
      state.invoiceBatches.push(new InvoiceBatch(item));
    });
  },
  UPDATE_INVOICE_BATCH(state, payload) {
    state.invoiceBatches = state.invoiceBatches.map((item) => {
      return item.invoiceBatchId == payload.invoiceBatchId
        ? new InvoiceBatch(payload)
        : item;
    });
  },
  DELETE_INVOICE_BATCH(state, invoiceBatchId) {
    state.invoiceBatches = state.invoiceBatches.filter(
      (item) => item.invoiceBatchId != invoiceBatchId
    );
  },
  SET_SELECTED_INVOICE_BATCH(state, payload) {
    state.selectedInvoiceBatch = new InvoiceBatch(payload);
  },
};

export const getters = {
  getInvoiceBatch: (state) => (invoiceBatchId) => {
    return state.invoiceBatches.find(
      (item) => item.invoiceBatchId === invoiceBatchId
    );
  },
  getOtherSessionInvoicesInGroup:
    (state) => (sessionInvoiceId, errorMessage) => {
      var groupId = state.selectedInvoiceBatch?.sessionInvoices.find(
        (item) => item.sessionInvoiceId === sessionInvoiceId
      )?.sessionGroupId;
      if (groupId) {
        return state.selectedInvoiceBatch?.sessionInvoices
          .filter(
            (item) =>
              item.sessionGroupId === groupId &&
              item.sessionInvoiceId != sessionInvoiceId // not itself
          )
          .map((obj) => new SessionInvoice({ ...obj, errorMessage }));
      }
      return [];
    },
};

export const actions = {
  async getAllServiceRates({ commit }, data) {
    return await api
      .get("/serviceRate/getAllEffectiveServiceRates", data)
      .then((response) => {
        if (response.success) {
          commit("SET_SERVICE_RATES", response.data);
        }
        return response.success;
      });
  },
  async createServiceRate({ commit }, data) {
    return await api
      .post("/serviceRate/createServiceRate", data)
      .then((response) => {
        if (response.success) {
          commit("ADD_SERVICE_RATE", response.data);
          return "";
        }
        return response.message;
      });
  },
  async updateServiceRate({ commit }, data) {
    return await api
      .post("/serviceRate/updateServiceRate", data)
      .then((response) => {
        if (response.success) {
          commit("UPDATE_SERVICE_RATE", response.data);
          return "";
        }
        return response.message;
      });
  },
  async deleteServiceRate({ commit }, data) {
    return await api
      .postQuery("/serviceRate/deleteServiceRate", {
        serviceRateId: data.serviceRateId,
      })
      .then((response) => {
        if (response.success) {
          commit("DELETE_SERVICE_RATE", data.serviceRateId);
        }
        return response.success;
      });
  },
  async invoiceSessions({ commit }, data) {
    let failures = [];
    for await (const sessionId of data.sessionIds) {
      let response = await api.postQuery("/sessionInvoice/invoiceSession", {
        sessionId: sessionId,
        invoiceDate: data.invoiceDate,
      });
      if (!response.success) {
        failures.push(sessionId);
      } else {
        commit("sessionModule/updateSessionInvoiceDetails", response.data, {
          root: true,
        });
      }
    }

    let message =
      failures.length > 0
        ? "Error invoicing: " + failures.join()
        : "All sessions successfully invoiced.";
    return message;
  },
  async createOverpaymentInvoice({}, data) {
    return await api
      .postQuery("/sessionInvoice/createOverpaymentSessionInvoice", {
        clientId: data.clientId,
        programId: data.programId,
        serviceId: data.serviceId,
        dateOfService: data.dateOfService,
        invoiceDate: data.invoiceDate,
      })
      .then((response) => {
        return response.success;
      });
  },
  async getAllInvoiceBatches({ commit }, data) {
    return await api
      .get("/invoiceBatch/getAllInvoiceBatches", data)
      .then((response) => {
        if (response.success) {
          commit("SET_INVOICE_BATCHES", response.data);
        }
        return response.success;
      });
  },
  async loadInvoiceBatch({ commit }, data) {
    return await api
      .getQuery("/invoiceBatch/loadInvoiceBatch", data)
      .then((response) => {
        if (response.success) {
          commit("SET_SELECTED_INVOICE_BATCH", response.data);
        }
        return response.success;
      });
  },
  async createInvoiceBatch({ commit }, data) {
    return await api
      .uploadFile(
        "/invoiceBatch/uploadInvoiceReport",
        { programId: data.programId, batchDate: data.batchDate },
        data.selectedFile
      )
      .then((response) => {
        if (response.success) {
          commit("ADD_INVOICE_BATCHES", response.data);
          if (response.data != null && response.data.length == 0) {
            return "No invoice batches created because no matching sessions found on uploaded report.";
          }
          return "";
        }
        return response.message;
      });
  },
  async updateInvoiceBatch({ commit }, data) {
    return await api
      .post("/invoiceBatch/updateInvoiceBatch", data)
      .then((response) => {
        if (response.success) {
          commit("UPDATE_INVOICE_BATCH", response.data);
          return "";
        }
        return response.message;
      });
  },
  async postInvoiceBatch({ commit }, data) {
    return await api
      .postQuery("/invoiceBatch/postInvoiceBatch", { ...data })
      .then((response) => {
        if (response.success) {
          commit("UPDATE_INVOICE_BATCH", response.data);
          return "";
        }
        return response.message;
      });
  },
  async deleteInvoiceBatch({ commit }, data) {
    return await api
      .postQuery("/invoiceBatch/deleteInvoiceBatch", {
        invoiceBatchId: data.invoiceBatchId,
      })
      .then((response) => {
        if (response.success) {
          commit("DELETE_INVOICE_BATCH", data.invoiceBatchId);
          return "";
        }
        return response.message;
      });
  },
  async exportInvoiceBatch({}, data) {
    return await api
      .postQuery("/invoiceBatch/exportInvoiceBatch", data)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        return false;
      });
  },
  async exportInvoiceBatches({}, data) {
    return await api
      .postQuery("/invoiceBatch/exportInvoiceBatches", data)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        return false;
      });
  },
  async uploadErrorsReportForInvoiceBatch({}, data) {
    return await api
      .uploadFile(
        "/invoiceBatch/uploadInvoiceErrorsReport",
        { invoiceBatchId: data.invoiceBatchId },
        data.selectedFile
      )
      .then((response) => {
        return response.data.map((item) => new SessionInvoice(item));
      })
      .catch((err) => {
        return [];
      });
  },
  async removeSessionInvoices({ dispatch }, data) {
    return await api
      .post("/invoiceBatch/removeSessionInvoices", data.sessionInvoiceIds)
      .then((response) => {
        if (response.success) {
          dispatch("loadInvoiceBatch", { invoiceBatchId: data.invoiceBatchId });
          return {
            removedInvoiceIds: response.data,
            message: response.message,
          };
        }
        return {
          removedInvoiceIds: [],
          message: response.message,
        };
      });
  },
  async removeAndFreeze({ dispatch }, data) {
    return await api
      .post(
        "/invoiceBatch/removeSessionInvoicesAndUnlockAndFreezeSessions",
        data.sessionInvoices
      )
      .then((response) => {
        if (response.success) {
          dispatch("loadInvoiceBatch", { invoiceBatchId: data.invoiceBatchId });
          return {
            removedInvoiceIds: response.data,
            message: response.message,
          };
        }
        return {
          removedInvoiceIds: [],
          message: response.message,
        };
      });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
